import { SVGUniqueID } from 'react-svg-unique-id'

import { ICON_GRADIENTS } from 'configs/iconColors'

interface Props {
  color?: [start: string, stop: string] | string
  type?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info'
  [key: string]: any
}

export function SmsFilled({ color, type, ...props }: Props) {
  const c = color || ICON_GRADIENTS[type || 'secondary']
  const selectedColor = typeof c === 'string' ? [c, c] : c

  return (
    <SVGUniqueID>
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
      >
        <path
          d='M3.05825 14.259H9.48616L14.9595 18.75V14.259H16.9359C17.9331 14.259 18.7441 13.4336 18.7441 12.4187V3.09027C18.7441 2.07536 17.9332 1.25 16.9359 1.25H3.05825C2.06098 1.25 1.25 2.07536 1.25 3.09027V12.4187C1.25 13.4336 2.06098 14.259 3.05825 14.259ZM14.2441 8.18452C13.5404 7.94749 13.2687 7.56469 13.2756 7.16054C13.2756 6.52683 13.8191 6.04635 14.6616 6.04635C15.0588 6.04635 15.4138 6.13657 15.6231 6.24121L15.4352 6.97261C15.2819 6.88878 14.9894 6.77721 14.6968 6.77721C14.4389 6.77721 14.2926 6.88185 14.2926 7.0559C14.2926 7.21606 14.425 7.29989 14.8431 7.44616C15.4907 7.6688 15.7624 7.99658 15.7694 8.49792C15.7694 9.13163 15.2681 9.59822 14.2926 9.59822C13.8469 9.59822 13.4496 9.50104 13.1923 9.36173L13.3803 8.60256C13.5751 8.72109 13.9793 8.86044 14.2927 8.86044C14.613 8.86044 14.7454 8.74887 14.7454 8.57482C14.7454 8.40023 14.6407 8.31694 14.2441 8.18452ZM8.26196 6.12272L8.31055 6.58238H8.33137C8.47764 6.36671 8.77714 6.04638 9.36227 6.04638C9.80112 6.04638 10.1492 6.26902 10.2955 6.62405H10.3094C10.4348 6.45 10.5881 6.31065 10.7482 6.21351C10.9367 6.10194 11.1454 6.04642 11.3964 6.04642C12.0509 6.04642 12.5458 6.50609 12.5458 7.5226V9.52893H11.5149V7.67637C11.5149 7.18147 11.3542 6.89585 11.0131 6.89585C10.7696 6.89585 10.595 7.06294 10.5256 7.2653C10.4979 7.34163 10.484 7.45323 10.484 7.53703V9.52893H9.4531V7.62032C9.4531 7.18839 9.29986 6.89585 8.96512 6.89585C8.69389 6.89585 8.53319 7.10513 8.47075 7.27918C8.43604 7.36248 8.42912 7.46016 8.42912 7.54399V9.52896H7.39822V7.20928C7.39822 6.78485 7.38433 6.42233 7.37044 6.12282H8.26196V6.12272ZM5.23273 8.18452C4.52907 7.94749 4.25734 7.56469 4.26427 7.16054C4.26427 6.52683 4.80777 6.04635 5.65023 6.04635C6.04746 6.04635 6.40302 6.13657 6.61173 6.24121L6.42379 6.97261C6.27056 6.88878 5.97802 6.77721 5.68544 6.77721C5.42756 6.77721 5.28129 6.88185 5.28129 7.0559C5.28129 7.21606 5.41367 7.29989 5.83171 7.44616C6.47931 7.6688 6.75104 7.99658 6.758 8.49792C6.758 9.13163 6.25671 9.59822 5.28129 9.59822C4.83551 9.59822 4.43828 9.50104 4.18098 9.36173L4.36891 8.60256C4.56378 8.72109 4.96793 8.86044 5.28132 8.86044C5.60164 8.86044 5.73406 8.74887 5.73406 8.57482C5.73406 8.40023 5.62942 8.31694 5.23273 8.18452Z'
          fill='url(#sms_linear)'
        />
        <defs>
          <linearGradient
            id='sms_linear'
            x1='1.25'
            y1='1.25'
            x2='1.25'
            y2='18.75'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor={selectedColor[0]} />
            <stop offset='1' stopColor={selectedColor[1]} />
          </linearGradient>
        </defs>
      </svg>
    </SVGUniqueID>
  )
}
